/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

export { wrapRootElement } from './src/apollo/wrap-root-element';

// fix browser cache issues after site updates
// https://github.com/gatsbyjs/gatsby/issues/9087
export const onServiceWorkerUpdateReady = () => window.location.reload();
